import { render, staticRenderFns } from "./NetworkMenu.vue?vue&type=template&id=234ed566&scoped=true&"
import script from "./NetworkMenu.vue?vue&type=script&lang=ts&"
export * from "./NetworkMenu.vue?vue&type=script&lang=ts&"
import style0 from "./NetworkMenu.vue?vue&type=style&index=0&id=234ed566&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234ed566",
  null
  
)

export default component.exports